import React from 'react';
import { FormattedMessage } from 'react-intl';
import { linkValidity } from './session';

// The link rules come from the tenant settings returned by ack-start (ackSettings), never from the page.
const ExpiredBody = ({ ackSettings }) => {
    const validity = linkValidity(ackSettings && ackSettings.linkValiditySeconds);
    const openings = ackSettings && ackSettings.maxOpenings;
    if (!validity || !Number.isInteger(openings) || openings <= 0) {
        return <FormattedMessage id="conventionPage.session.expired.bodyNoSettings" />;
    }
    return (
        <FormattedMessage
            id="conventionPage.session.expired.body"
            values={{
                validity: <FormattedMessage id={`conventionPage.duration.${validity.unit}`} values={{ value: validity.value }} />,
                openings,
            }}
        />
    );
};

const SessionExpiredNotice = ({ ackSettings }) => (
    <div className="hia-ack-alert" role="alert" data-testid="session-expired">
        <p className="hia-ack-alert-title"><FormattedMessage id="conventionPage.session.expired.title" /></p>
        <p><FormattedMessage id="conventionPage.session.expired.lead" /></p>
        <p><ExpiredBody ackSettings={ackSettings} /></p>
    </div>
);

export default SessionExpiredNotice;
